import { render, staticRenderFns } from "./Minutes.vue?vue&type=template&id=42481b61&scoped=true&"
import script from "./Minutes.vue?vue&type=script&lang=js&"
export * from "./Minutes.vue?vue&type=script&lang=js&"
import style0 from "./Minutes.vue?vue&type=style&index=0&id=42481b61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42481b61",
  null
  
)

export default component.exports